module.exports = __webpack_public_path__ + "static/media/profile.50ee5138.png";